import {createAction, props} from '@ngrx/store';
import {VPC} from '../../../services/api/account/vpcs/vpc.model';

const category = '[OrganizationVPCList]';

export const loadOrganizationVPCList = createAction(
  `${category} Load Organization VPC List`
);

export const loadOrganizationVPCListSuccess = createAction(
  `${category} Load Organization VPC List Success`,
  props<{ data: VPC[] }>()
);

export const loadOrganizationVPCListFailure = createAction(
  `${category} Load Organization VPC List Failure`,
  props<{ error: any }>()
);

export const clearOrganizationVPCListState = createAction(
  `${category} Clear Organization VPC List State`
);
